import React from 'react';

import { PopupWraper } from '../../../components/popup';
import UpdateForm from './updateForm';

interface UpdateUserProps {
  userId: string;
  onClose: () => void;
  forceUpdateTable: () => void;
  refetchLeadersList: () => void;
}

const UpdateUser = ({
  userId,
  onClose,
  forceUpdateTable,
  refetchLeadersList,
}: UpdateUserProps) => {
  return (
    <div className='wrap-pop-up-update-user'>
      <PopupWraper title='Cập nhật thông tin người dùng' onClose={onClose}>
        <UpdateForm
          userId={userId}
          onClose={onClose}
          forceUpdateTable={forceUpdateTable}
          refetchLeadersList={refetchLeadersList}
        />
      </PopupWraper>
    </div>
  );
};

export default UpdateUser;
